import CardItem from "./CardItem"

const CardPanel = (props) => {

    const { items } = props

    return (
        <section className="flex w100 white-bkg">
            <section className="flex wrap acenter jcenter pad-30 gap-30 main-middle-section-2 white-bkg">

                {
                    items?.map((item, index) =>
                        <CardItem key={index} item={item} />
                    )
                }
            </section>
        </section>
    )

}

export default CardPanel